import { render, staticRenderFns } from "./OcorrenciasShow.vue?vue&type=template&id=0755ed78&scoped=true&"
import script from "./OcorrenciasShow.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0755ed78",
  null
  
)

export default component.exports